import request from '@/utils/request'

// 查询公告管理列表
export function getNoticeList(data) {
  return request({
      url: '/system/notice/list',
      method: 'get',
      params: data
  })
}

// 导出公告管理列表
export function exportNoticeList(data) {
  return request({
      url: '/system/notice/export',
      method: 'get',
      params: data
  })
} 

// 获取公告管理详细信息
export function getNoticeInfo(data) {
  return request({
      url: '/system/notice/getInfo/'+data.noticeId,
      method: 'get',
      data: data
  });
}

// 新增公告管理
export function addNotice(data) {
  return request({
      url: '/system/notice/add',
      method: 'post',
      data: data
  });
}

// 修改公告管理
export function updateNotice(data) {
  return request({
      url: '/system/notice/edit',
      method: 'post',
      data: data
  });
}

// 删除公告管理
export function deleteNotice(data) {
  return request({
      url: '/system/notice/delete/' + data.noticeId,
      method: 'post',
      data: data
  });
}